import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';


import p8 from '../assets/images/edu.gif';

const IndexPage = () => (
  <Layout>
    <Header />

    <div className="col-lg-6">
            <a className="portfolio-item" href="#">
              <span className="caption">
                <span className="caption-content">
                  <h2></h2>
                  <p className="mb-0">
                   <b>Learn with just a click...</b>
                  </p>
                </span>
              </span>
              <img className="img-fluid" src={p8} alt="" />
            </a>


          </div>

   

    


    

    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://udemy.com/" className="btn btn-xl btn-light mr-4">
         Udemy
        </a>
        <a href="http://khanacademy.org/" className="btn btn-xl btn-dark">
          Khan Academy
        </a>
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://codeacademy.com/" className="btn btn-xl btn-light mr-4">
        Code Academy
        </a>
        <a href="http://lessonpaths.com/" className="btn btn-xl btn-dark">
         Lesson Paths
        </a>
      </div>
    </section>


     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://alison.com/" className="btn btn-xl btn-light mr-4">
          Alison
        </a>
        <a href="http://academicearth.org/" className="btn btn-xl btn-dark">
          Academic Earth
        </a>
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.linkedin.com/learning/" className="btn btn-xl btn-light mr-4">
          Linkedin Learning
        </a>
        <a href="https://generalassemb.ly/" className="btn btn-xl btn-dark">
          General Assembly
        </a>
      </div>
    </section>




    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.skillshare.com/" className="btn btn-xl btn-light mr-4">
          Skill Share
        </a>
        <a href="http://academicearth.org/" className="btn btn-xl btn-dark">
          Academic Earth
        </a>
      </div>
    </section>



    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.vectorsolutions.com/about-us/acquisitions/learnsmart/" className="btn btn-xl btn-light mr-4">
         Learn Smart
        </a>
        <a href="https://www.pluralsight.com/" className="btn btn-xl btn-dark">
          Plural Sight
        </a>
      </div>
    </section>


 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <h2 className="mb-5">Learn anything on the Internet Smartly.. <i className="fa fa-graduation-cap fa-spin"></i></h2>
        </div>
        
      </div>
    </section>





 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://helpx.adobe.com/creative-cloud/tutorials-explore.html" className="btn btn-xl btn-light mr-4">
        Adobe
        </a>
        <a href="https://www.futurelearn.com/courses?filter_availability=upcoming" className="btn btn-xl btn-dark">
      Future Learn
        </a>
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.coursera.org/" className="btn btn-xl btn-light mr-4">
        Coursera 
        </a>
        <a href="http://wikipedia.org/" className="btn btn-xl btn-dark">
        Wikipedia
        </a>
      </div>
    </section>





     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.drawspace.com/" className="btn btn-xl btn-light mr-4">
       DrawSpace 
        </a>
        <a href="https://edu.gcfglobal.org/en/" className="btn btn-xl btn-dark">
        Learn Free
        </a>
      </div>
    </section>






     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://openculture.com/" className="btn btn-xl btn-light mr-4">
         Open Culture
        </a>
        <a href="http://edx.org/" className="btn btn-xl btn-dark">
          Edx
        </a>
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://extension.harvard.edu/" className="btn btn-xl btn-light mr-4">
         Harvard Extension
        </a>
        <a href="http://online.standford.edu/" className="btn btn-xl btn-dark">
        Stanford Online
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.udacity.com/" className="btn btn-xl btn-light mr-4">
         Udacity
        </a>
        <a href="https://www.mentalfloss.com/" className="btn btn-xl btn-dark">
         Mental Floss
        </a>
      </div>
    </section>




 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <h2 className="mb-5">Life never stops teaching,never stop learning.. <i className="fa fa-graduation-cap fa-spin"></i></h2>
        </div>
        
      </div>
    </section>

<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://hackdesign.org/" className="btn btn-xl btn-light mr-4">
         Hack Design
        </a>
        <a href="https://htmldog.com/" className="btn btn-xl btn-dark">
         HTML Dog
        </a>
      </div>
    </section>




    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.instructables.com/" className="btn btn-xl btn-light mr-4">
         Instructables
        </a>
        <a href="https://itunesu.itunes.apple.com/coursemanager/" className="btn btn-xl btn-dark">
        itunes U
        </a>
      </div>
    </section>



    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://iversity.org/" className="btn btn-xl btn-light mr-4">
         iversity
        </a>
        <a href="https://www.lifehack.org/" className="btn btn-xl btn-dark">
         Life Hack
        </a>
      </div>
    </section>


    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://ocw.mit.edu/" className="btn btn-xl btn-light mr-4">
         MIT Open CourseWare
        </a>
        <a href="http://oli.cmu.edu/independent-learner-courses/" className="btn btn-xl btn-dark">
         OPen Learning
        </a>
      </div>
    </section>


    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://oyc.yale.edu/" className="btn btn-xl btn-light mr-4">
         Open Yale
        </a>
        <a href="http://podcasts.ox.ac.uk/series" className="btn btn-xl btn-dark">
         Oxford Courses
        </a>
      </div>
    </section>


<section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <h2 className="mb-5">An Investment in knowledge pays the best interest.. <i className="fa fa-graduation-cap fa-spin"></i></h2>
        </div>
        
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://skillcrush.com/" className="btn btn-xl btn-light mr-4">
         Skill Crush
        </a>
        <a href="https://see.stanford.edu/" className="btn btn-xl btn-dark">
         Stanford Engineering Everywhere
        </a>
      </div>
    </section>



    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.upwork.com/resources" className="btn btn-xl btn-light mr-4">
         Up Work
        </a>
        <a href="https://betterexplained.com/" className="btn btn-xl btn-dark">
        Better Explained
        </a>
      </div>
    </section>




    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.thinkful.com/" className="btn btn-xl btn-light mr-4">
         ThinkFul
        </a>
        <a href="https://www.canvas.net/" className="btn btn-xl btn-dark">
         Canvas
        </a>
      </div>
    </section>


   












    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
